import { Controller } from '@hotwired/stimulus';
import tippy from 'tippy.js';

export default class extends Controller {
  static values = {
    content: String,
    placement: String,
    theme: { type: String, default: 'tooltip' },
    maxWidth: String,
  };

  connect() {
    const options = {
      theme: this.themeValue,
      content: this.contentValue,
      allowHTML: true,
    };

    if (this.hasPlacementValue) options.placement = this.placementValue;
    if (this.hasMaxWidthValue) options.maxWidth = this.maxWidthValue;

    this.tippy = tippy(this.element, options);
  }

  disconnect() {
    this.tippy.destroy();
  }
}
